import React from "react"
import {Badge, Tab, type TabProps} from "@mui/material"
import {useLocation, useNavigate} from "react-router-dom"
import styled from "styled-components"

import {useCustomerID} from "../useCustomerID"

import {useOfferStatus} from "@indebted/api/customerOffersAPI"

function OffersTab(props: TabProps) {
	const customerID = useCustomerID()
	const location = useLocation()
	const navigate = useNavigate()
	const isActive = location.pathname.endsWith("/offers")
	const offerStatus = useOfferStatus(customerID)
	const badgeColor = offerStatus === "available" ? "success" : offerStatus === "upcoming" ? "warning" : undefined

	return (
		<StyledTab
			{...props}
			label={
				<Badge
					variant="dot"
					color={badgeColor}
					invisible={isActive || !badgeColor}
					sx={{"& .MuiBadge-dot": {right: -8}}}
				>
					Offers
				</Badge>
			}
			onClick={() => navigate(`/customers/${customerID}/offers${location.search}`)}
		/>
	)
}

const StyledTab = styled(Tab)`
	min-width: auto;
	max-width: auto;
	padding: 6px 12px;
`

OffersTab.muiName = "Tab"

export {OffersTab}
